import { distinctUntilChanged } from "rxjs/operators";

export function plainObjectComparator<T>(a: T, b: T): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}

export const distinctUntilPlainObjectChanged = distinctUntilChanged(plainObjectComparator);
